export default __webpack_public_path__ + "static/media/Eva01.ae6691a1.jpg";